export default "__VITE_ASSET__Bn5Xf9YP__"